// file path: src\Pages\TeamOverviewPage\teamAverages.slice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TeamAverages } from '../../services/member.service';

interface TeamAveragesState {
  data: TeamAverages | null;
  loading: boolean;
  error: string | null;
}

const initialState: TeamAveragesState = {
  data: null,
  loading: false,
  error: null,
};

const teamAveragesSlice = createSlice({
  name: 'teamAverages',
  initialState,
  reducers: {
    setTeamAveragesLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTeamAveragesData: (state, action: PayloadAction<TeamAverages>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setTeamAveragesError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearTeamAverages: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setTeamAveragesLoading,
  setTeamAveragesData,
  setTeamAveragesError,
  clearTeamAverages,
} = teamAveragesSlice.actions;

export default teamAveragesSlice.reducer;
